import React from 'react';
import { CreateMaterialData } from '../types/adminContent';

interface Props {
  formData: CreateMaterialData;
  onChange: (data: CreateMaterialData) => void;
  onSubmit: () => void;
  onClose: () => void;
}

const CreateMaterialModal: React.FC<Props> = ({ formData, onChange, onSubmit, onClose }) => (
  <div className="modal-overlay" onClick={onClose}>
    <div className="modal-content" onClick={e => e.stopPropagation()}>
      <div className="modal-header">
        <h3>✨ Create New Material</h3>
        <button onClick={onClose}>×</button>
      </div>
      <div className="modal-body">
        <div className="form-grid">
          <div className="form-group">
            <label>Material Name *</label>
            <input
              type="text"
              value={formData.name}
              onChange={e => onChange({ ...formData, name: e.target.value })}
              placeholder="e.g., Iron Ore"
            />
          </div>

          <div className="form-group">
            <label>Material Type *</label>
            <select
              value={formData.materialType}
              onChange={e => onChange({ ...formData, materialType: e.target.value })}
            >
              <option value="Wood">Wood</option>
              <option value="Ore">Ore</option>
              <option value="Herbs">Herbs</option>
              <option value="Gem">Gem</option>
              <option value="Cloth">Cloth</option>
              <option value="Leather">Leather</option>
              <option value="Food">Food</option>
              <option value="Potion">Potion</option>
            </select>
          </div>

          <div className="form-group">
            <label>Rarity *</label>
            <select
              value={formData.rarity}
              onChange={e => onChange({ ...formData, rarity: e.target.value })}
            >
              <option value="Common">Common</option>
              <option value="Uncommon">Uncommon</option>
              <option value="Rare">Rare</option>
              <option value="Epic">Epic</option>
              <option value="Legendary">Legendary</option>
            </select>
          </div>

          <div className="form-group">
            <label>Base Value</label>
            <input
              type="number"
              min="1"
              value={formData.baseValue}
              onChange={e => onChange({ ...formData, baseValue: parseInt(e.target.value) })}
            />
          </div>

          <div className="form-group">
            <label>Icon Name</label>
            <input
              type="text"
              value={formData.iconName}
              onChange={e => onChange({ ...formData, iconName: e.target.value })}
              placeholder="e.g., iron-ore"
            />
          </div>

          <div className="form-group">
            <label>
              <input
                type="checkbox"
                checked={formData.isActive}
                onChange={e => onChange({ ...formData, isActive: e.target.checked })}
              />
              Active
            </label>
          </div>

          <div className="form-group full-width">
            <label>Description</label>
            <textarea
              value={formData.description}
              onChange={e => onChange({ ...formData, description: e.target.value })}
              placeholder="Describe this material..."
              rows={3}
            />
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button className="cancel-button" onClick={onClose}>Cancel</button>
        <button
          className="create-button"
          onClick={onSubmit}
          disabled={!formData.name}
        >
          ✨ Create Material
        </button>
      </div>
    </div>
  </div>
);

export default CreateMaterialModal;
